import React, { useEffect, useState } from 'react'
import { Loader } from '@navent-jobs/ui-kit/components/loader'
import { useSelector } from 'react-redux'
import { ApplyCouponButton } from './components/ApplyCouponButton'
import { CouponInput } from './components/CouponInput'
import { ContentLoader } from './mixins'
import { AppStore } from '../../../../../store'
import { ValorizedCartState } from '../../../../../store/cart-v2/valorized/types'
import { CouponState } from '../../../../../store/coupon/types'

export const CartCoupon = () => {
  const { fetchCoupon } = useSelector<AppStore, CouponState>(({ couponStore }) => couponStore)
  const [isInputVisible, setIsInputVisible] = useState<boolean>(false)
  const { statusCart } = useSelector<AppStore, ValorizedCartState>(({ cartStoreV2 }) => cartStoreV2.valorized)
  useEffect(() => {
    fetchCoupon.couponCode && setIsInputVisible(true)
  }, [fetchCoupon.couponCode])

  if (statusCart.loading || fetchCoupon.status.loading) {
    return (
      <ContentLoader>
        <Loader />
      </ContentLoader>
    )
  }

  return isInputVisible ? (
    <CouponInput isInputVisible={isInputVisible} setIsInputVisible={setIsInputVisible} />
  ) : (
    <ApplyCouponButton isInputVisible={isInputVisible} setIsInputVisible={setIsInputVisible} />
  )
}
